<template>
<v-container
    color="white"
>

                <v-card
            class="mx-auto mt-12"
            color="white"
        >
          <v-card-title primary-title>
            PASARELA DE PAGO
          </v-card-title>
          <v-card-text>
             <v-row class="mt-n2">
                <v-col cols="6" xs="6">
                 <v-switch v-model="pagoEfectivo" label="Efectivo"></v-switch>
                <strong class="red--text"> {{otros.pagoEfectivo}} </strong>
                </v-col>
                <v-col cols="6" xs="6">
                   <v-switch v-model="pagoenTienda" label="Recojo en tienda"></v-switch>
                <strong class="red--text">  {{otros.pagoenTienda}}</strong>
                </v-col>
                <v-col cols="6" xs="6">
                   <v-switch v-model="pagodepositoCuenta" label="Deposito a Cuenta"></v-switch>
                <strong class="red--text">  {{otros.pagodepositoCuenta}}</strong>
                </v-col>
             </v-row>
          </v-card-text>
                
        <v-card-actions class="mt-n6">
            <v-btn
             :disabled="disabled"
              block
              color="success"
              class="mr-4"
              @click="grabaOtrostiposdePago"
              >
              Grabar
            </v-btn>
        </v-card-actions>
        </v-card>
    
     <v-card
    class="mt-4"
    color="white"

  >
        <v-card-title class="mx-auto">
         <h5 class="mx-auto">Datos Cuentas de Pago</h5>
        </v-card-title>

        <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
                <v-row class="mt-n6">
                <v-col cols="6" xs="6">
                        <v-text-field
                        :disabled="disabled"
                        v-model="banco"
                        :rules="rules"
                        label="Banco"
                        required
                    ></v-text-field>
                </v-col>
                <v-col cols="6" xs="6">
                         <v-text-field
                        :disabled="disabled"
                        v-model="cuenta"
                        :rules="rules"
                        label="Nº Cuenta"
                        required
                    ></v-text-field>
                </v-col>
                </v-row>
            </v-form>
              
        </v-card-text>
        
        <v-card-actions class="mt-n6">
            <v-btn
             :disabled="disabled"
              block
              color="success"
              class="mr-4"
              @click.stop="grabar()"
              >
              Agregar
            </v-btn>
        </v-card-actions>

  </v-card>

        <v-card
            v-for="ba in bancos" :key="ba"
            class="mx-auto mt-1 pa-2"
            color="white"
            width="400px"
        >
        {{ba.banco}} : {{ba.cuenta}}
                <v-btn class="ma-2"
                @click="eliminar(ba.banco)"
                text icon color="red lighten-2">
                      <v-icon small>fas fa-minus</v-icon>
                </v-btn>
        </v-card>

         <v-card
    class="mx-auto mt-4"
    color="white"

  >
        <v-card-title class="mx-auto">
         <h5 class="mx-auto">Mi YAPE</h5>
        </v-card-title>

        <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
                <v-row class="mt-n6">
                <v-col cols="6" xs="6">
                <v-text-field
                  :disabled="disabled"
                   v-model="numeroyape"
                  :rules="rules"
                  label="Numero Asociado"
                  required
                ></v-text-field>
                 <v-file-input
                label="Foto YAPE"
                filled
                v-model="selectedFile"
                prepend-icon="mdi-camera"
              ></v-file-input>
                </v-col>
                <v-col cols="6" xs="6">
            <v-img class="mx-auto" max-height="150px" max-width="150px"  aspect-ratio="1"
            :src="imagenyape.foto">
        </v-img>
                </v-col>
                 </v-row>

            </v-form>
              
        </v-card-text>
        
        <v-card-actions class="mt-n6">
           <v-row class="mt-n6">
                <v-col cols="6" xs="6">
            <v-btn
             :disabled="disabled"
              block
              color="success"
              class="mr-4"
              @click.stop="grabarYAPE()"
              >
              Agregar
            </v-btn>
                </v-col>
                <v-col cols="6" xs="6">
            <v-btn
             :disabled="disabled"
              block
              color="error"
              class="mr-4"
              @click.stop="eliminaYAPE()"
              >
              elimina
            </v-btn>
                </v-col>
           </v-row>

        </v-card-actions>
  </v-card>


        <v-card
            class="mx-auto mt-2"
            color="white"
        >
          <v-card-title primary-title>
            Coodinar Pago por WhatsApp: 
          </v-card-title>
          <v-card-text>
            Numero inscrito: {{whatsappbd.pagoWhatsapp}} - Estado: {{whatsappbd.pagoWhatsappactivo}} 
             <v-row class="mt-n2">
                <v-col cols="6" xs="6">
                <v-text-field
                  :disabled="disabled"
                   v-model="pagoWhatsapp"
                  label="Numero WhatsApp"
                ></v-text-field>
                </v-col>
                <v-col cols="6" xs="6">
                   <v-switch v-model="pagoWhatsappactivo" label="Activo?"></v-switch>
                </v-col>
             </v-row>
          </v-card-text>
                
        <v-card-actions class="mt-n6">
            <v-btn
             :disabled="disabled"
              block
              color="success"
              class="mr-4"
              @click="grabarpagoWhatsapp"
              >
              Grabar
            </v-btn>
        </v-card-actions>
        </v-card>



 <v-dialog
            v-model="progress"
            max-width="200"
            >
            <v-card>
                 <v-progress-circular
                  :rotate="90"
                  :size="200"
                  :width="15"
                  :value="Uploadvalue"
                  color="red"
                >
                  {{ Uploadvalue }}
                </v-progress-circular>
            </v-card>

         </v-dialog>

</v-container>
</template>

<script>
// @ is an alias to /src
import { db } from '../db'
import firebase from 'firebase'

export default {
  name: 'datosgestiondePago',

      firebase: {
        bancos: db.database().ref("pagos").child("bancos"),
        imagenyape: db.database().ref("pagos").child("yape"),
        whatsappbd: db.database().ref("pagos").child("whatsapp"),
        otros: db.database().ref("pagos").child("otros"),
      },


  data(){
    return{
        disabled:false,
         valid: true,
        bancos:[],
        imagenyape:{},
        banco:'',
        cuenta:'',
        numeroyape:'',
        rules: [
        v => !!v || 'Obligatorio',
        v => (v && v.length > 0 ) || 'No puede ser vacio',
      ],
       progress: false,
        selectedFile:null,
        Uploadvalue:0,
        picture:null,
        pagoWhatsapp:'',
        pagoWhatsappactivo:false,
        whatsappbd:'',
        pagoEfectivo:false,
        pagoenTienda:false,
        pagodepositoCuenta:false,
        otros:''

    }
  },
   created() {
    this.pagoWhatsappactivo = this.whatsappbd.pagoWhatsappactivo
    this.pagoWhatsapp = this.whatsappbd.pagoWhatsapp
    this.pagodepositoCuenta =this.whatsappbd.pagodepositoCuenta
    this.pagoEfectivo = this.otros.pagoEfectivo
  },

  methods: {
    agregar(){
        this.validate()
    if(this.bancos!="" && this.cuenta!=""){
        this.grabar()
    }
    },
    grabar(){
            db.database().ref("pagos").child("bancos").child(this.banco).set({
                banco:this.banco,
                cuenta:this.cuenta,
            });
              this.banco="",
              this.cuenta=""
    },
    eliminar(dato){
            db.database().ref("pagos").child("bancos").child(dato).remove()
    },

     validate () {
            this.$refs.form.validate()
        },
    grabarYAPE(){
        this.progress = true
         const storageRef = db.storage().ref(`/imagenYape/yape`)
         const task=storageRef.put(this.selectedFile)
         task.on('state_changed',snapshot=>{
      
           let porcentaje = (snapshot.bytesTransferred/snapshot.totalBytes)*100
           this.Uploadvalue = porcentaje
         },error=>{console.log(error.message)},
         ()=>{this.Uploadvalue=100;
              task.snapshot.ref.getDownloadURL().then((url)=>{
                db.database().ref("pagos").child("yape").set({
                    codigo:"yape",
                    foto:url,
                    numeroyape:this.numeroyape
                    });
                this.progress = false
                console.log(this.picture)
              })
         }
         )
    },
    eliminaYAPE(){
        db.database().ref("pagos").child("yape").remove()
    },

    grabarpagoWhatsapp(){
      if(this.pagoWhatsapp!=''){
            db.database().ref("pagos").child("whatsapp").set({
                pagoWhatsapp:this.pagoWhatsapp,
                pagoWhatsappactivo:this.pagoWhatsappactivo,
            });
      }
    },
    grabaOtrostiposdePago(){
            db.database().ref("pagos").child("otros").set({
                    pagoEfectivo:this.pagoEfectivo,
                     pagoenTienda:this.pagoenTienda,
                     pagodepositoCuenta:this.pagodepositoCuenta
            });
    }
    
    },
}
</script>
